import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsCancelButton = (props: Props) => {
  const { disabled, onPress } = props;

  return (
    <Button
      size="large-wide"
      style={styles.button}
      width="100%"
      palette="spinachMuted"
      disabled={disabled}
      onPress={onPress}
      accessibilityRole="button"
    >
      <FormattedMessage {...messages.cancel} />
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
    borderWidth: 1,
    borderColor: theme.colors.KALE,
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Add To Bag | Unavailable ingredients | Cancel CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  disabled: boolean;
  onPress: () => void;
};
